import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, vShow as _vShow, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "main" }
const _hoisted_2 = {
  id: "Nav",
  class: "left"
}
const _hoisted_3 = { class: "back" }
const _hoisted_4 = ["aria-label"]
const _hoisted_5 = { class: "content" }
const _hoisted_6 = { class: "maintitle s60" }
const _hoisted_7 = { class: "desc" }
const _hoisted_8 = { class: "buttons" }
const _hoisted_9 = {
  class: "cta secondary s16",
  "data-color": "white"
}
const _hoisted_10 = ["href"]
const _hoisted_11 = ["action"]
const _hoisted_12 = { class: "or" }
const _hoisted_13 = ["value"]
const _hoisted_14 = ["src", "alt"]
const _hoisted_15 = ["value"]
const _hoisted_16 = {
  id: "Main",
  class: "right"
}
const _hoisted_17 = {
  class: "logo",
  "data-color": "cyan50"
}
const _hoisted_18 = ["href"]
const _hoisted_19 = ["alt"]
const _hoisted_20 = { class: "intro" }
const _hoisted_21 = { class: "maintitle s36" }
const _hoisted_22 = {
  ref: "form",
  class: "form"
}
const _hoisted_23 = ["disabled"]
const _hoisted_24 = {
  key: 0,
  class: "item"
}
const _hoisted_25 = { for: "UserName" }
const _hoisted_26 = { class: "item" }
const _hoisted_27 = { for: "Email" }
const _hoisted_28 = ["placeholder"]
const _hoisted_29 = { class: "item" }
const _hoisted_30 = { for: "EmailCheck" }
const _hoisted_31 = ["placeholder"]
const _hoisted_32 = { class: "item" }
const _hoisted_33 = {
  class: "label",
  "data-link": ""
}
const _hoisted_34 = ["href"]
const _hoisted_35 = { class: "item" }
const _hoisted_36 = { for: "Password" }
const _hoisted_37 = {
  class: "custominput",
  "data-type": "password"
}
const _hoisted_38 = ["aria-label"]
const _hoisted_39 = { class: "item" }
const _hoisted_40 = { for: "PasswordCheck" }
const _hoisted_41 = {
  class: "custominput",
  "data-type": "password"
}
const _hoisted_42 = ["aria-label"]
const _hoisted_43 = {
  class: "item",
  "data-label": "top"
}
const _hoisted_44 = { for: "ProfileSegment" }
const _hoisted_45 = { value: null }
const _hoisted_46 = ["value"]
const _hoisted_47 = ["disabled"]
const _hoisted_48 = {
  class: "item",
  "data-type": "list"
}
const _hoisted_49 = { class: "checkbox" }
const _hoisted_50 = { for: "IsNewsletterSubscription" }
const _hoisted_51 = ["innerHTML"]
const _hoisted_52 = {
  key: 0,
  class: "validation-summary-errors"
}
const _hoisted_53 = { class: "cta" }
const _hoisted_54 = ["innerHTML"]

import { ref, onBeforeMount } from "vue";
import Axios from "axios";
import FormHelper from "@Scripts/Common/FormHelper";
import Localizer from "@Scripts/Common/Localizer";


export default /*@__PURE__*/_defineComponent({
  __name: 'AccountRegister',
  props: {
    returnUrl: {},
    recaptchaSiteKey: {},
    email: {},
    profileSegment: {},
    urlPrivacyPolicy: {}
  },
  setup(__props: any) {

const props = __props;

const localizer = Localizer;
const formHelper = FormHelper;
const routes = (window as any).App.routes;

const isLoading = ref(false);
const isSuccess = ref(false);
const isFromNewsletter = ref(false);
const options = ref<any>(null);
const profileSegments = ref<any[]>([]);
const formData = ref<any>({ profileSegment: null, isNewsletterSubscription: false });
const validationErrors = ref<any[]>([]);
const isHidden = ref(true);
const isHiddenCheck = ref(true);

onBeforeMount(async () => {
    options.value = (await Axios.post(routes.Account_User_GetOptions, null, { headers: { "RequestVerificationToken": FormHelper.getRequestVerificationToken() } })).data;
    profileSegments.value = options.value.profileSegments;
    if (props.email && props.profileSegment) {
        formData.value.email = props.email;
        formData.value.profileSegment = props.profileSegment;
        isFromNewsletter.value = true;
    }
});

function isEmailInUse(): boolean {
    return (validationErrors.value.length !== 0 && validationErrors.value.filter((x: any) => x.message === localizer.get("Account.Common.Email_InUse")).length > 0);
}

function showPasswordIcon() {
    isHidden.value = !isHidden.value;
}

function showPasswordCheckIcon() {
    isHiddenCheck.value = !isHiddenCheck.value;
}

function goBack() {
    props.returnUrl ? (window.location.href = props.returnUrl) : history.back();
}

async function submitForm() {
    FormHelper.removeFocus();
    validationErrors.value = [];
    isLoading.value = true;

    (window as any).grecaptcha.enterprise.ready(async () => {
        const token = await (window as any).grecaptcha.enterprise.execute(props.recaptchaSiteKey, { action: "Submit" });
        try {
            let result = ( await Axios.post(routes.Account_User_Register, formData.value, { headers: { "RequestVerificationToken": FormHelper.getRequestVerificationToken(), RecaptchaVerificationToken: token }, })).data;
            isSuccess.value = true;
            window.location.href = result.redirectUrl ? result.redirectUrl : props.returnUrl ? props.returnUrl : "/";
        } catch (error: any) {
            formData.value.password = null;
            formData.value.passwordCheck = null;
            if (error.response && error.response.status === 400) {
                validationErrors.value = FormHelper.getValidationErrors(error.response.data);
            }
        }
        isLoading.value = false;
    });
}

return (_ctx: any,_cache: any) => {
  const _component_app_footer = _resolveComponent("app-footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (goBack())),
          class: "button icon fastic-circle-left",
          "aria-label": _unref(localizer).get('App.Common.PageBack')
        }, null, 8, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("h1", _hoisted_6, _toDisplayString(_unref(localizer).get("Account.AccountRegister.Title")), 1),
        _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(localizer).get("Account.AccountRegister.Desc")), 1),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("a", {
              href: _unref(routes).Account_User_Login + (__props.returnUrl ? '?returnurl=' + __props.returnUrl : ''),
              class: "button"
            }, _toDisplayString(_unref(localizer).get("Account.Login.LoginTitle")), 9, _hoisted_10)
          ]),
          (options.value && options.value.externalProviders.length !== 0 && !isFromNewsletter.value)
            ? (_openBlock(), _createElementBlock("form", {
                key: 0,
                action: _unref(routes).Account_External_ExternalLogin + (__props.returnUrl ? '?returnurl=' + __props.returnUrl : ''),
                method: "post",
                class: "external"
              }, [
                _createElementVNode("fieldset", null, [
                  _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(localizer).get("App.Common.Or")), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.value.externalProviders, (provider, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "cta secondary s16 icon",
                      "data-color": "white"
                    }, [
                      _createElementVNode("button", {
                        type: "submit",
                        name: "provider",
                        value: provider.name,
                        class: "button"
                      }, [
                        _createElementVNode("img", {
                          src: '/images/' + provider.name + '.svg',
                          width: "20",
                          height: "20",
                          class: "icon",
                          alt: provider.name
                        }, null, 8, _hoisted_14),
                        _createTextVNode("Accedi con " + _toDisplayString(provider.name), 1)
                      ], 8, _hoisted_13)
                    ]))
                  }), 128))
                ]),
                _createElementVNode("input", {
                  type: "hidden",
                  name: "__RequestVerificationToken",
                  value: _unref(formHelper).getRequestVerificationToken()
                }, null, 8, _hoisted_15)
              ], 8, _hoisted_11))
            : _createCommentVNode("", true)
        ])
      ]),
      _createVNode(_component_app_footer)
    ]),
    _createElementVNode("main", _hoisted_16, [
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("a", {
          href: _unref(routes).Home
        }, [
          _createElementVNode("img", {
            src: "/images/logo.svg",
            width: "125",
            height: "35",
            alt: _unref(localizer).get('App.Common.Beghelli')
          }, null, 8, _hoisted_19)
        ], 8, _hoisted_18)
      ]),
      (options.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            onKeydown: _cache[11] || (_cache[11] = _withKeys(_withModifiers(($event: any) => (submitForm()), ["prevent","stop"]), ["enter"])),
            class: "content"
          }, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("h2", _hoisted_21, _toDisplayString(_unref(localizer).get("Account.Login.CreateProfile")), 1)
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("fieldset", { disabled: isLoading.value }, [
                (options.value.isUserName)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                      _createElementVNode("label", _hoisted_25, _toDisplayString(_unref(localizer).get("Account.Common.UserName")), 1),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        id: "UserName",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.userName) = $event)),
                        class: _normalizeClass([{ 'input-validation-error': _unref(formHelper).isControlValidationError('UserName', validationErrors.value) }, 'input w300'])
                      }, null, 2), [
                        [
                          _vModelText,
                          formData.value.userName,
                          void 0,
                          { lazy: true }
                        ]
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _withDirectives(_createElementVNode("div", _hoisted_26, [
                  _createElementVNode("label", _hoisted_27, _toDisplayString(_unref(localizer).get("App.Form.Email")), 1),
                  _withDirectives(_createElementVNode("input", {
                    type: "email",
                    id: "Email",
                    placeholder: _unref(localizer).get('App.Form.EmailPlaceholder'),
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.email) = $event)),
                    class: _normalizeClass([{ 'input-validation-error': _unref(formHelper).isControlValidationError('Email', validationErrors.value) }, 'input w300'])
                  }, null, 10, _hoisted_28), [
                    [
                      _vModelText,
                      formData.value.email,
                      void 0,
                      { lazy: true }
                    ]
                  ])
                ], 512), [
                  [_vShow, !isFromNewsletter.value]
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_29, [
                  _createElementVNode("label", _hoisted_30, _toDisplayString(_unref(localizer).get("Account.Common.EmailCheck")), 1),
                  _withDirectives(_createElementVNode("input", {
                    type: "email",
                    id: "EmailCheck",
                    placeholder: _unref(localizer).get('App.Form.EmailPlaceholder'),
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.emailCheck) = $event)),
                    class: _normalizeClass([{ 'input-validation-error': _unref(formHelper).isControlValidationError('EmailCheck', validationErrors.value) }, 'input w300'])
                  }, null, 10, _hoisted_31), [
                    [
                      _vModelText,
                      formData.value.emailCheck,
                      void 0,
                      { lazy: true }
                    ]
                  ])
                ], 512), [
                  [_vShow, options.value.isEmailCheck]
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, [
                    _createTextVNode(_toDisplayString(_unref(localizer).get("Account.Common.Email_InUse_RetrieveText")) + " ", 1),
                    _createElementVNode("a", {
                      href: _unref(routes).Account_User_PasswordRemind,
                      class: "link"
                    }, _toDisplayString(_unref(localizer).get("Account.Common.Email_InUse_RetrieveLink")), 9, _hoisted_34)
                  ])
                ], 512), [
                  [_vShow, isEmailInUse()]
                ]),
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("label", _hoisted_36, _toDisplayString(_unref(localizer).get("Account.Common.Password")), 1),
                  _createElementVNode("div", _hoisted_37, [
                    _withDirectives(_createElementVNode("input", {
                      type: "password",
                      "aria-label": _unref(localizer).get('Account.Common.Password'),
                      id: "Password",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.password) = $event)),
                      class: _normalizeClass([{ 'input-validation-error input-validation-error-update': _unref(formHelper).isControlValidationError('Password', validationErrors.value) }, 'input w300'])
                    }, null, 10, _hoisted_38), [
                      [
                        _vModelText,
                        formData.value.password,
                        void 0,
                        { lazy: true }
                      ]
                    ]),
                    _createElementVNode("button", {
                      class: _normalizeClass([{ 'fastic-eye-show': isHidden.value, 'fastic-eye-hide': !isHidden.value }, 'showhide']),
                      "aria-label": "Mostra password",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_unref(formHelper).showPassword('Password'), showPasswordIcon()))
                    }, null, 2)
                  ])
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_39, [
                  _createElementVNode("label", _hoisted_40, _toDisplayString(_unref(localizer).get("Account.Common.PasswordCheck")), 1),
                  _createElementVNode("div", _hoisted_41, [
                    _withDirectives(_createElementVNode("input", {
                      type: "password",
                      "aria-label": _unref(localizer).get('App.Form.PasswordCheck'),
                      id: "PasswordCheck",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.passwordCheck) = $event)),
                      class: _normalizeClass([{ 'input-validation-error': _unref(formHelper).isControlValidationError('PasswordCheck', validationErrors.value) }, 'input w300'])
                    }, null, 10, _hoisted_42), [
                      [
                        _vModelText,
                        formData.value.passwordCheck,
                        void 0,
                        { lazy: true }
                      ]
                    ]),
                    _createElementVNode("button", {
                      class: _normalizeClass([{ 'fastic-eye-show': isHiddenCheck.value, 'fastic-eye-hide': !isHiddenCheck.value }, 'showhide']),
                      "aria-label": "Mostra password",
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_unref(formHelper).showPassword('PasswordCheck'), showPasswordCheckIcon()))
                    }, null, 2)
                  ])
                ], 512), [
                  [_vShow, options.value.isPasswordCheck]
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_43, [
                  _createElementVNode("label", _hoisted_44, _toDisplayString(_unref(localizer).get("App.Common.AddFunctionalities")), 1),
                  _withDirectives(_createElementVNode("select", {
                    id: "ProfileSegment",
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formData.value.profileSegment) = $event)),
                    class: _normalizeClass([{ 'input-validation-error': _unref(formHelper).isControlValidationError('ProfileSegment', validationErrors.value) }, 'input w460'])
                  }, [
                    _createElementVNode("option", _hoisted_45, _toDisplayString(_unref(localizer).get("App.Form.Select")), 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(profileSegments.value, (profileSegment, index) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: profileSegment.value,
                        key: index
                      }, _toDisplayString(profileSegment.title), 9, _hoisted_46))
                    }), 128))
                  ], 2), [
                    [_vModelSelect, formData.value.profileSegment]
                  ])
                ], 512), [
                  [_vShow, !isFromNewsletter.value]
                ])
              ], 8, _hoisted_23),
              _createElementVNode("fieldset", { disabled: isLoading.value }, [
                _createElementVNode("div", _hoisted_48, [
                  _createElementVNode("div", _hoisted_49, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      id: "IsNewsletterSubscription",
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formData.value.isNewsletterSubscription) = $event))
                    }, null, 512), [
                      [_vModelCheckbox, formData.value.isNewsletterSubscription]
                    ]),
                    _createElementVNode("label", _hoisted_50, _toDisplayString(_unref(localizer).get('App.Form.NewsletterSubscription')), 1)
                  ])
                ]),
                _createElementVNode("div", {
                  class: "desc small",
                  innerHTML: _unref(localizer).get('App.Form.PrivacyA', _unref(routes).UrlPrivacyPolicy)
                }, null, 8, _hoisted_51),
                (validationErrors.value.length !== 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                      _createElementVNode("ul", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(validationErrors.value, (validationError, index) => {
                          return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(validationError.message), 1))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_53, [
                  _createElementVNode("button", {
                    class: _normalizeClass([{ 'loading': isLoading.value }, 'button']),
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (submitForm()))
                  }, [
                    (!isLoading.value)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(_unref(localizer).get('App.Form.CreateProfile')), 1)
                        ], 64))
                      : _createCommentVNode("", true)
                  ], 2)
                ])
              ], 8, _hoisted_47),
              _createElementVNode("div", {
                class: "desc small grecaptcha-terms",
                innerHTML: _unref(localizer).get('App.Support.Captcha_Terms')
              }, null, 8, _hoisted_54)
            ], 512)
          ], 32))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})